import React from "react";

// Solar Citadel Logo — gold ring, three gold chevron pillars (central piercing top),
// crimson geometric flame at the base.
export const SolarCitadelLogo = ({ size = 44, className = "", ...props }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Vivasvan Solar Citadel"
      {...props}
    >
      {/* Outer gold ring */}
      <circle
        cx="50"
        cy="52"
        r="38"
        fill="none"
        stroke="#D4AF37"
        strokeWidth="3"
      />

      {/* Three chevron pillars — sharp upward peaks */}
      {/* Left pillar */}
      <polygon
        points="22,72 30,44 38,72"
        fill="none"
        stroke="#D4AF37"
        strokeWidth="2.5"
        strokeLinejoin="miter"
      />
      {/* Central pillar — tallest, piercing top of ring */}
      <polygon
        points="38,72 50,6 62,72"
        fill="none"
        stroke="#D4AF37"
        strokeWidth="3"
        strokeLinejoin="miter"
      />
      {/* Right pillar */}
      <polygon
        points="62,72 70,44 78,72"
        fill="none"
        stroke="#D4AF37"
        strokeWidth="2.5"
        strokeLinejoin="miter"
      />

      {/* Geometric crimson flame at base */}
      <polygon
        points="40,80 50,60 60,80 55,80 50,72 45,80"
        fill="#7A1C1C"
      />
      <polygon
        points="44,84 50,72 56,84"
        fill="#7A1C1C"
        opacity="0.85"
      />
    </svg>
  );
};

export const BrandLockup = ({ compact = false }) => {
  return (
    <div className="flex items-center gap-3" data-testid="brand-lockup">
      <SolarCitadelLogo size={compact ? 40 : 52} />
      <div className="leading-tight">
        <div
          className="font-serif text-bone tracked-lg"
          style={{ fontSize: compact ? "1.05rem" : "1.25rem", fontWeight: 600 }}
        >
          VIVASVAN
        </div>
        <div
          className="font-sans text-steel tracked"
          style={{ fontSize: compact ? "0.55rem" : "0.62rem", fontWeight: 500 }}
        >
          ENERGIES VENTURES (PTY) LTD
        </div>
      </div>
    </div>
  );
};
